// Internal URL utilities that inject window.location.origin as baseUrl.
// Dashboard resolves the base via wrapper functions in utils/url.ts
// (window.location.origin in the browser, the server-only DOMAIN env var on the
// server); here we use window.location.origin directly.

import {
  appendSearchParamsToUrl as baseAppend,
  removeSearchParamsFromUrl as baseRemove,
  sanitizeUrl,
} from '@bridge/utils';

import type { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';

const getBaseUrl = () => (typeof window !== 'undefined' ? window.location.origin : '');

export function appendSearchParamsToUrl(url: string, params: Record<string, string>): string {
  return baseAppend(url, params, getBaseUrl());
}

export function removeSearchParamsFromUrl(url: string, params: string[]): string {
  return baseRemove(url, params, getBaseUrl());
}

export type UrlUpdateMode = 'rsc' | 'client';

export function updateUrlState({
  url,
  mode,
  router,
}: {
  url: string;
  mode: UrlUpdateMode;
  router: AppRouterInstance | null;
}): void {
  if (typeof window === 'undefined') return;

  const sanitizedUrl = sanitizeUrl(url);

  if (mode === 'client') {
    window.history.replaceState(null, '', sanitizedUrl);
  } else if (router) {
    router.replace(sanitizedUrl);
  }
}
